import { FC } from 'react';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

import { compress, decompress } from 'lz-string'
import { store } from './store/configureStore';

import AuthAlert from './components/blocks/auth-alert';
import ErrorBoundary from './components/common/errorBoundary';
import Wrapper from './components/common/wrapper';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
		  	staleTime: Infinity,
			retry: 2, // Retry failed requests twice
			refetchOnWindowFocus: false, // Don't refetch when switching tabs
			refetchOnReconnect: true, // Refetch when back online
			refetchOnMount: 'always',
			networkMode: 'offlineFirst'
		},
	},
});

const localStoragePersister = createSyncStoragePersister({
	storage: window.localStorage,
	serialize: (data) => compress(JSON.stringify(data)),
    deserialize: (data) => JSON.parse(decompress(data)),
});

persistQueryClient({
	queryClient: queryClient as any,
	persister: localStoragePersister,
	maxAge: Infinity,
});

const App: FC = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<AuthAlert />
				
				<ErrorBoundary>
					<Wrapper />
				</ErrorBoundary>
			</Provider>
		</QueryClientProvider>
	);
};

export default App;
